import styled from "styled-components";

const allStars = /\*+/g;
type Props = {
  stars: string, max: number
}
const StarsSkeleton = ({ stars, max }: Props) => {
  const width = 60;

  const widths = [
    width * 0.5,
    width * 0.4,
    width * 0.3,
    width * 0.2,
    width * 0.1,
  ];
  const result = stars ? stars.match(allStars) : "";

  const starsCount = result ? result[0].length : 0;
  const limitedStarsCount = starsCount > max ? max : starsCount;

  const lengths = Array(5)
    .fill(0)
    .map((_, i) => {
      if (i === 0) {
        return Math.floor(limitedStarsCount / 5);
      } else {
        return limitedStarsCount % 5 === 5 - i ? 1 : 0;
      }
    });

  return (
    <>
      {Array(lengths[0])
        .fill(0)
        .map((_, index) => {
          return (
            <StyledSymbolSkeleton
              className="bg-skeleton"
              key={index}
              style={{
                width: widths[0],
              }}
            />
          );
        })}
      {lengths[1] ? (
        <StyledSymbolSkeleton
          className="bg-skeleton"
          style={{
            width: widths[1],
          }}
        />
      ) : null}
      {lengths[2] ? (
        <StyledSymbolSkeleton
          className="bg-skeleton"
          style={{
            width: widths[2],
          }}
        />
      ) : null}
      {lengths[3] ? (
        <StyledSymbolSkeleton
          className="bg-skeleton"
          style={{
            width: widths[3],
          }}
        />
      ) : null}
      {lengths[4] ? (
        <StyledSymbolSkeleton
          className="bg-skeleton"
          style={{
            width: widths[4],
          }}
        />
      ) : null}
    </>
  );
};

export default StarsSkeleton;
const StyledSymbolSkeleton = styled.span`
  height: 10px;
  border-radius: 10px;
  margin: 0 2px;
`;
